import { USE_FEDERATED_AUTH } from 'config';
import { useUser as useUserForms } from './formsAuthHooks';
import { useUser as useUserFederated } from './federatedAuthHooks';

export const useUser = () => {
  const formsResult = useUserForms();
  const federatedResult = useUserFederated();

  return USE_FEDERATED_AUTH ? federatedResult : formsResult;
};
